import { call, put, takeEvery } from 'redux-saga/effects';

import { gcApi } from 'config/axios';

// src/backbone/lib/map/GarminMap.js
// @ts-ignore
import Garmin from 'garminmap';
import { FETCH_ACTIVITY_MAP_DETAILS, FETCH_ACTIVITY_MAP_DETAILS_BAIDU } from 'actions/ActionTypes';
import { fetchActivityMapDetailsDone } from '../reducers/activityMapDetails/activityMapDetailsReducer';
import BaiduConvertService from 'Map/utils/BadiuConvertService';

/**
 * decode gPolyline to geoPolylineDTO (partial) for web to work
 * @param {{
 *  activityId: number;
 *  numberOfPoints: number;
 *  encodedSamples: string;
 *  encodedLevels: string;
 *  maxLat: number;
 *  maxLon: number;
 *  minLat: number;
 *  minLon: number;
 *  startLat: number;
 *  startLon: number;
 *  endLat: number;
 *  endLon: number;
 * }} gPolyline
 * @returns
 */
export function decodeGPolylineToGeoPolylineDTO(gPolyline) {
    if (!gPolyline) {
        return null;
    }

    const array = Garmin.Map.Utils.decodeLine(gPolyline.encodedSamples);
    const polyline = array.map((item) => {
        const garminPoint = new Garmin.Map.Point(item[0], item[1]);
        return { lat: garminPoint.lat, lon: garminPoint.lon };
    });

    const geoPolylineDTO = {
        minLat: gPolyline.minLat,
        maxLat: gPolyline.maxLat,
        minLon: gPolyline.minLon,
        maxLon: gPolyline.maxLon,
        startPoint: null,
        endPoint: null,
        polyline
    };

    if (Array.isArray(polyline) && polyline.length > 0) {
        const startLatLon = polyline[0];
        const endLatLon = polyline[polyline.length - 1];
        geoPolylineDTO.startPoint = {
            lat: startLatLon.lat,
            lon: startLatLon.lon
        };
        geoPolylineDTO.endPoint = {
            lat: endLatLon.lat,
            lon: endLatLon.lon
        };
    }
    return geoPolylineDTO;
}

function* fetchActivityDetails(action) {
    const { activityId, maxPolylineSize, maxHeatMapSize, splitTypes } = action;

    const params = {
        maxPolylineSize,
        maxHeatMapSize
    };
    let splitTypeQueryString = '';
    if (Array.isArray(splitTypes)) {
        splitTypeQueryString = splitTypes.map((item) => `splitType=${item}`).join('&');
    }
    const response = yield call(
        gcApi.get,
        `/activity-service/activity/${activityId}/mapdetails?${splitTypeQueryString}`,
        { params }
    );
    const { activityHeatMapDTO = null, gPolyline = null } = response.data || {};
    const geoPolylineDTO = decodeGPolylineToGeoPolylineDTO(gPolyline);

    return { activityHeatMapDTO, geoPolylineDTO };
}

export function* fetchActivityMapDetailsSaga(action) {
    const { activityId } = action;
    try {
        const { activityHeatMapDTO, geoPolylineDTO } = yield call(fetchActivityDetails, action);
        yield put(
            fetchActivityMapDetailsDone(activityId, {
                error: false,
                data: {
                    activityHeatMapDTO,
                    geoPolylineDTO
                }
            })
        );
    } catch (error) {
        yield put(fetchActivityMapDetailsDone(activityId, { error: true, data: null }));
    }
}

export function* fetchActivityMapDetailsBaiduSaga(action) {
    const { activityId } = action;

    try {
        const { activityHeatMapDTO, geoPolylineDTO } = yield call(fetchActivityDetails, action);

        const polylinePoints = geoPolylineDTO?.polyline;

        let convertService = new BaiduConvertService();

        if (activityHeatMapDTO) {
            let inputPoints = [
                { latitude: activityHeatMapDTO.lowerLeftLat || 0, longitude: activityHeatMapDTO.lowerLeftLon || 0 },
                { latitude: activityHeatMapDTO.upperRightLat || 0, longitude: activityHeatMapDTO.upperRightLon || 0 }
            ];
            const heatMapDTOPoints = activityHeatMapDTO.points || [];
            inputPoints = inputPoints.concat(heatMapDTOPoints);
            const convertResponse = yield convertService.fetchGenerator(inputPoints);
            const rect = convertResponse.slice(0, 2);
            const newDataPoints = convertResponse.slice(2);
            activityHeatMapDTO.lowerLeftLat = rect[0].lat;
            activityHeatMapDTO.lowerLeftLon = rect[0].lon;
            activityHeatMapDTO.upperRightLat = rect[1].lat;
            activityHeatMapDTO.upperRightLon = rect[1].lon;
            newDataPoints.forEach((convertedPoint, index) => {
                heatMapDTOPoints[index].lat = convertedPoint.lat;
                heatMapDTOPoints[index].lon = convertedPoint.lon;
            });
        } else if (polylinePoints) {
            const convertResponse = yield convertService.fetchGenerator(polylinePoints);
            convertResponse.forEach((convertedPoint, index) => {
                polylinePoints[index].lat = convertedPoint.lat;
                polylinePoints[index].lon = convertedPoint.lon;
            });
        }

        yield put(
            fetchActivityMapDetailsDone(activityId, {
                error: false,
                data: {
                    activityHeatMapDTO,
                    geoPolylineDTO
                }
            })
        );
    } catch (error) {
        yield put(fetchActivityMapDetailsDone(activityId, { error: true, data: null }));
    }
}

export const activityMapDetailsSagas = [
    takeEvery(FETCH_ACTIVITY_MAP_DETAILS, fetchActivityMapDetailsSaga),
    takeEvery(FETCH_ACTIVITY_MAP_DETAILS_BAIDU, fetchActivityMapDetailsBaiduSaga)
];
